import { BaseType } from '../../base/base-type';
import { LifeStatusIdEnum } from '../../enum/shared/life-status-id.enum';

export class LifeStatus extends BaseType {
  public declare id: LifeStatusIdEnum;
}
